export class DeviceService {

  static serviceId = "device";
  static $inject = [];

  private phone: boolean;
  private andoird: boolean;

  constructor() {
    var ua = navigator.userAgent;

    if (/android/ig.test(ua)) {
      this.andoird = true;
      if (/mobile/ig.test(ua)) {
        this.phone = true;
      } else {
        var x = $(window);
        if ((x.height() > 800 && x.width() < 700) || x.height() < 600 && x.width() > 900) {
          this.phone = true;
        } else {
          this.phone = false;
        }
      }
    } else {
      this.phone = true;
    }
  }

  isAndroid = () => {
    return this.andoird;
  }

  isTablet = () => {
    return !this.phone;
  }

  isPhone = () => {
    return this.phone;
  }
}